import React from "react";
import { SliderValueLabelProps, Tooltip } from "@mui/material";

/**
 * Custom slider value label that renders in a Tooltip to avoid overflow issues due to widget size.
 */
const SliderValueLabelTooltip: React.FC<SliderValueLabelProps> = ({ children, open, value }: SliderValueLabelProps) => {
  return (
    <Tooltip
      open={open}
      title={value}
      PopperProps={{
        disablePortal: false,
      }}
    >
      {children}
    </Tooltip>
  );
};

export default SliderValueLabelTooltip;
